import CommonCurrancy from "./CommonCurrency.json";

export type currencyObj = {
  key: string;
  label: string;
  symbol: string;
  name: string;
  symbol_native: string;
  decimal_digits: number;
  rounding: number;
  code: string;
  name_plural: string;
};

// union of all currency keys
export type currencyUnionType = keyof typeof CommonCurrancy;

// array of currency keys
export const currencyKeys = Object.keys(CommonCurrancy) as currencyUnionType[];

// array of currencies
const currencyArray = currencyKeys.map((currency) => ({
  ...CommonCurrancy[currency],
  label: `${CommonCurrancy[currency].code} - ${CommonCurrancy[currency].name}`,
  key: currency,
}));

// currency object with key and label
export const CurrenciesObject = currencyArray.reduce(
  (a, v) => ({ ...a, [v.key]: v }),
  {} as { [k in currencyUnionType]: currencyObj }
);

// currency dropdown options
export const currencyOptions = currencyArray.map((currency) => ({
  value: currency.label,
  label: currency.label,
}));

export const findCurrencySymbol = (selectedValue: string) => {
  return currencyArray.find((e) => e.label === selectedValue)?.symbol;
};
